module.exports = __webpack_public_path__ + "img/img131.17cbfe30.svg";